module.exports = __webpack_public_path__ + "static/media/iron.293f24f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/iron.svg
// module id = 560
// module chunks = 0